(() => {
  const swatchSelector = '.cwl-product-card variant-swatch-king .star-set-image';
  const swatchRootSelector = '.cwl-product-card variant-swatch-king';

  function moveSwatchIntoProductInfo(element) {
    if (!(element instanceof Element)) return;

    const card = element.closest('.cwl-product-card');
    const info = card?.querySelector('.card > .card__content > .card__information');
    const price = info?.querySelector('.card-information');
    if (!card || !info || !price || info.contains(element)) return;

    // Swatch King can inject its element directly below the media. Keep it
    // in the product information stack, between title and price.
    info.insertBefore(element, price);
  }

  function fitSwatch(element) {
    if (!(element instanceof Element) || !element.matches(swatchSelector)) return;

    const background = element.style.backgroundImage || window.getComputedStyle(element).backgroundImage;
    const match = background.match(/^url\(["']?(.*?)["']?\)$/);

    if (!match) return;

    let imageUrl;

    try {
      imageUrl = new URL(match[1], window.location.href);
    } catch (error) {
      return;
    }

    if (!imageUrl.hostname.endsWith('cdn.shopify.com')) return;
    if (!imageUrl.searchParams.has('height') && !imageUrl.searchParams.has('crop')) return;

    imageUrl.searchParams.delete('height');
    imageUrl.searchParams.delete('crop');

    element.style.setProperty('background-image', `url("${imageUrl.toString()}")`, 'important');
    element.style.setProperty('background-position', 'center', 'important');
    element.style.setProperty('background-repeat', 'no-repeat', 'important');
    element.style.setProperty('background-size', 'contain', 'important');
  }

  function fitSwatches(root) {
    if (root instanceof Element && root.matches(swatchSelector)) fitSwatch(root);
    if (!root.querySelectorAll) return;

    root.querySelectorAll(swatchSelector).forEach(fitSwatch);
    root.querySelectorAll(swatchRootSelector).forEach(moveSwatchIntoProductInfo);
  }

  function start() {
    const main = document.querySelector('#MainContent') || document.body;

    fitSwatches(main);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          fitSwatch(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) fitSwatches(node);
          if (node.nodeType === Node.ELEMENT_NODE) {
            const card = node.closest?.('.cwl-product-card');
            if (card) fitSwatches(card);
          }
        });
      });
    }).observe(main, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', (event) => fitSwatches(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
